import { render, staticRenderFns } from "./actionsBuilder.vue?vue&type=template&id=064020dc"
import script from "./actionsBuilder.vue?vue&type=script&lang=js"
export * from "./actionsBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports